import { FC, useState } from 'react'
import { List, Card, Typography } from 'antd'
import { useLocation, useNavigate } from 'react-router-dom'
import { relayStore } from '../../store/relay'
import {
	RNChecks,
	RNJournal,
	RNRelayType
} from '../../helpers/routeNames'
import { SearchInput } from '../../components/SearchInput'
import { PageBreadcrumb } from '../../components/PageBreadcrumb'

const { Title } = Typography

export const RelayType: FC = () => {
	const { relayTypes } = relayStore()
	const navigate = useNavigate()
	const [, setFilteredData] = useState(relayTypes)

	const location = useLocation()

	return (
		<div>
			<PageBreadcrumb
				items={[
					{
						label:
							location.pathname === RNChecks
								? 'Типы реле'
								: 'Журнал'
					}
				]}
			/>
			<header
				style={{
					display: 'flex',
					justifyContent: 'space-between',
					alignItems: 'center'
				}}>
				<Title level={2}>
					{location.pathname === RNChecks
						? 'Типы реле'
						: 'Журнал'}
				</Title>
			</header>
			<main>
				<SearchInput
					data={relayTypes}
					searchFields={['name']}
					onSearch={setFilteredData}
					placeholder="Поиск по названию типа реле">
					{(data) => (
						<List
							grid={{
								gutter: 16,
								column: 4,
								xs: 1,
								sm: 2,
								md: 3
							}}
							dataSource={data}
							renderItem={(relayType) => (
								<List.Item>
									<Card
										styles={{
											body: {
												padding:
													'0px 24px 24px'
											}
										}}
										title={relayType.name}
										onClick={() =>
											navigate(
												location.pathname ===
													RNChecks
													? RNRelayType +
															'/' +
															relayType.id
													: RNJournal +
															'/' +
															relayType.id
											)
										}
										hoverable
										style={{ width: '100%' }}>
										<h3>Информация</h3>
										Создано:{' '}
										{new Date(
											relayType.createdAt
										).toLocaleString('ru')}
										<br />
									</Card>
								</List.Item>
							)}
						/>
					)}
				</SearchInput>
			</main>
		</div>
	)
}
